/*
 |--------------------------------------------------------------------------
 | Relay 42 event publisher
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 CONSTANTS
 \* ========================================================================== */

const
  /**
   * The module name
   * @type {String}
   */
  moduleName = 'eventTracking',
  /**
   * Lookup table for attributes
   * @type {Object}
   */
  attributes = {
    trackingEvent: `data-track-event`
  },
  /**
   * Lookup table for selectors
   * @type {Object}
   */
  selectors = {
    trackingElement: `[${attributes.trackingEvent}]`
  };

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
 SETUP EVENT TRACKING
 \* ========================================================================== */

class EventTracking {
  constructor(element) {
    let trackEventData;

    this.element = element;
    this.trackEvent = this.element.dataset.trackEvent;

    try {
      trackEventData = JSON.parse(this.element.dataset?.trackEventData || null);
    } catch (e) {
      console.log(e);
    }

    if (trackEventData) {
      this.trackEventData = trackEventData;
      this.element.addEventListener(this.trackEvent, this.handleEvent.bind(this));
    }
  }

  handleEvent(event) {
    const clientData = {
      'text': this.element.textContent,
      'location': window.location.href
    };

    if (event.target.href) {
      clientData['target'] = event.target.href;
    }

    this.publishEvent(this.trackEvent,{...clientData, ...this.trackEventData});
  }

  publishEvent(event, data) {
    if (window && window._st && window._st.event) {
      window._st.event.publish('result', event, data);
    } else {
      console.log('_st.publish', ['result', event, data]);
    }
  }
}
/* == END SETUP EVENT TRACKING ===================================================== */

/* ========================================================================== *\
 INITIALIZATION
 \* ========================================================================== */

function createEventTrackingInstance(element) {
  new EventTracking(element);
}

// Create tracking instances on DOM load
document.querySelectorAll(selectors.trackingElement).forEach(createEventTrackingInstance);

// Create tracking instances on DOM mutation
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(element => {
      if (element instanceof Element) {
        // Check the added node...
        if (element.hasAttribute(attributes.trackingEvent)) {
          createEventTrackingInstance(element);
        }

        // ...and the children
        element.querySelectorAll(selectors.trackingElement).forEach(createEventTrackingInstance)
      }
    });
  })
});

observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});

/* == END INITIALIZATION ==================================================== */
